export default {
    loading: false,
    perfil: {}
}